import 'core-js/stable'
import 'focus-visible'
import '../styles/global-styles'
import '@product-web/validation/yup'

import {render} from 'react-dom'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'

import {initSentry} from '@product-web/error/sentry'

import {initDataDog} from './datadog'
import {getRoutes} from './routes'

initDataDog()
initSentry()

const router = createBrowserRouter(getRoutes())
const renderApp = () => render(<RouterProvider router={router} />, document.getElementById('app'))

if (import.meta.env.MODE === 'development') {
    import('./load-mocks-in-local')
        .then(async ({loadMocksInLocal}) => loadMocksInLocal())
        .then(() => {
            renderApp()
        })
        .catch((error) => {
            throw error
        })
} else {
    renderApp()
}
